/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { BsQrCodeScan } from "react-icons/bs";
import { TfiClose } from "react-icons/tfi";
import { CiCircleRemove } from "react-icons/ci";
import QrReader from "react-qr-reader";
import { useTranslation } from "react-i18next";
import Select from 'react-select';
import { userService as plateRelatedService } from '../../../../service/plateServices';
import { IoSearchSharp } from "react-icons/io5";
import CustomToast from "../../../../widgets/toaster";




interface AddExceptionModelProps {
  show: boolean;
  isPlateSampling?: boolean;
  isRawMaterialTest?: boolean;
  exceptionReasons: { id: string; reason: string }[];
  samleTestType: { id: string; test_type: string }[];
  rawMaterialType: { id: string; material_type: string }[];
  rawMaterialSub: { id: string; material_type: string }[];
  plateBySerielNo: {
    plateSerielNo: string;
    productionName: string;
    productName: string;
    plateType: string;
    batchId: string;
  }[];
  addExceptionData: {
    remarks: string;
    reason_id: string;
    other_reason: string;
    user_id: number;
    area_id: string;
    subCategory_id: string;
  };
  errors: {
    scan_plate?: string;
    reason_id?: string;
    other_reason?: string;
    remarks?: string;
    subCategory_id?: string;
  };
  showToast: boolean;
  setShowToast: React.Dispatch<React.SetStateAction<boolean>>;
  setToastMessage: React.Dispatch<React.SetStateAction<string>>;
  setToastType: React.Dispatch<React.SetStateAction<string>>;
  toastMessage: string;
  toastType: string;
  loading: boolean;

  handleExceptionAlert: () => void;
  handleAddExceptionChange: (e: any) => void;
  addExceptionClose: () => void;
  handleModalOpen: () => void;
  getPlateDetailsBySerielNo: (slNo: string) => void;
  setPlateBySerielNo: (e: any) => void;
}

export const AddExceptionModel: React.FC<AddExceptionModelProps> = ({
  show,
  isPlateSampling,
  isRawMaterialTest,
  plateBySerielNo,
  errors,
  addExceptionData,
  exceptionReasons,
  samleTestType,
  rawMaterialType,
  rawMaterialSub,
  showToast,
  toastMessage,
  toastType,
  loading,

  addExceptionClose,
  getPlateDetailsBySerielNo,
  handleModalOpen,
  handleAddExceptionChange,
  handleExceptionAlert,
  setPlateBySerielNo,
  setShowToast,
  setToastMessage,
  setToastType,
}) => {
  const { t } = useTranslation();
  const scanAreaRef = useRef<HTMLInputElement>(null);


  const [newResult, setResult] = useState("");
  const [haveSlNo, setHaveSlNo] = useState(false);
  const [plateSerielNum, setPlateSerielNums] = useState([]);
  const [plateBatches, setPlateBatches] = useState([]);
  const [selectedSerielNo, setSelectedSerielNo] = useState("");
  const [debouncedScanCode, setDebouncedScanCode] = useState('');
  const [clicked, setClicked] = useState(false);



  // handle scan serial number
  const handleScanSerielNo2 = (result: any) => {
    console.log('Original Result:', result);
    if (haveSlNo) {
      setHaveSlNo(false)
      return
    }
    if (result.trim() !== "") {
      // setResult(result);
      try {
        const parsedResult = JSON.parse(result);
        if (typeof parsedResult === 'object') {
          let serialNumber;

          if (parsedResult.hasOwnProperty('serial_number')) {
            serialNumber = parsedResult.serial_number;
          } else {

            console.log(t("exceptionHandling.noSerialNoFound"));
            setToastMessage(t("exceptionHandling.noSerialNoFound"))
            setToastType("error")
            setShowToast(true)
          }
          if (serialNumber) {
            getPlateDetailsBySerielNo(serialNumber);
            setResult(serialNumber);
            setHaveSlNo(true)
          }
        } else {
          console.log(t("exceptionHandling.parsedResultAlert"));
          setToastMessage(t("exceptionHandling.parsedResultAlert"))
          setToastType("error")
          setShowToast(true)
        }
      } catch (error) {
        // getPlateDetailsBySerielNo(result);
        setToastMessage(t("exceptionHandling.noSerialNoFound"))
        setToastType("error")
        setShowToast(true)
        console.error('Error parsing JSON:', error);
      }
    }
  };

  const handleScanSerielNo = (result: any) => {
    console.log('Original Result:', result);

    if (haveSlNo) {
      setHaveSlNo(false);
      return;
    }

    if (result.trim() !== "") {
      try {
        const parsedResult = JSON.parse(result);

        if (typeof parsedResult === 'object' && parsedResult !== null) {
          let serialNumber;

          // Case-insensitive search for 'serial_number'
          const serialKey = Object.keys(parsedResult).find(
            key => key.toLowerCase() === 'serial_number'
          );

          if (serialKey) {
            serialNumber = parsedResult[serialKey];
          } else {
            console.log(t("exceptionHandling.noSerialNoFound"));
            setToastMessage(t("exceptionHandling.noSerialNoFound"));
            setToastType("error");
            setShowToast(true);
          }

          if (serialNumber) {
            getPlateDetailsBySerielNo(serialNumber);
            setResult(serialNumber);
            setHaveSlNo(true);
          }
        } else {
          console.log(t("exceptionHandling.parsedResultAlert"));
          setToastMessage(t("exceptionHandling.parsedResultAlert"));
          setToastType("error");
          setShowToast(true);
        }
      } catch (error) {
        setToastMessage(t("exceptionHandling.noSerialNoFound"));
        setToastType("error");
        setShowToast(true);
        console.error('Error parsing JSON:', error);
      }
    }
  };

  // handle remove icon click
  const handleRemovePlate = (id: any) => {
    setPlateBySerielNo((prevState: any) => prevState.filter((plate: any) => plate.plateSerielId !== id));
  }

  // handle modal close
  const handleModalClose = () => {
    addExceptionClose();
    setResult("");
    setClicked(false)
  }

  // batch list for filter dropdown 
  const listPlateBatch = async () => {
    try {
      const response = await plateRelatedService.listPlateBatch();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any, index: number) => {

              return {
                value: element.batch_number,
                label: element.batch_number,
                key: "batchCode",
              };
            });
            setPlateBatches(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //serial number listing for table drop down 
  const listSerialNumber = async () => {
    try {
      const response = await plateRelatedService.listSerialNumber();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map((element: any, index: number) => {

              return {
                value: element.serial_number,
                label: element.serial_number,
                key: "serielNumber",
              };
            });
            setPlateSerielNums(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  // handle change in select field
  const handleSelectChange = (selectedOption: any) => {
    if (selectedOption?.key === "batchCode") {
      listBatchPlateDetails(selectedOption?.value)
    }
    if (selectedOption?.key === "serielNumber") {
      getPlateDetailsBySerielNo(selectedOption?.value)
    }
    // if (selectedOption?.key === "lotCode") {
    //   setSelectedBatch(selectedOption?.batchCode);
    // }
  };

  //list plate batch detail 
  const listBatchPlateDetails = async (batch_number: any) => {
    try {
      const response = await plateRelatedService.listPlateByBatch(batch_number);
      console.log(response, "response---")
      if (response.status && response.statusCode === 200) {
        if (Array.isArray(response.data) && response.data?.length > 0) {
          // setBatchByTotalPages(response?.totalPages)
          // setBatchByTotalElements(response?.totalElements)
          let rowData: any = response.data.map((element: any, index: number) => {
            const role = element.role_master_id === "1" ?
              "Admin" : element.role_master_id === "2" ?
                "Operator" : element.role_master_id === "3" ?
                  "Lab Operator" : null
            //  const statusNumber = parseInt(element.plate_status, 10); 
            //  const status = plateRelatedService.getPlateStatus(statusNumber);
            const statusNumber = parseInt(element.plate_status, 10);
            let plateStatus = plateRelatedService.getPlateStatus(statusNumber);

            // Function to get incubation order suffix
            const getOrdinalSuffix = (num: number): string => {
              if (num % 100 >= 11 && num % 100 <= 13) return "th"; // general approach for higher than two digits
              switch (num % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
              }
            };

            if ((statusNumber === 12 || statusNumber === 13) && element.incubation_counter > 0) {
              const suffix = getOrdinalSuffix(element.incubation_counter);
              plateStatus = `${element.incubation_counter}${suffix} ${plateStatus}`;
            }
            return {
              id: element.id,
              slno: index + 1,
              batch_number: element.batch_number,
              serial_number: element.serial_number,
              manufacturing_date: element.manufacturing_date,
              expiry_date: element.expiry_date,
              status: plateStatus,
            };
          });
          // setBatchPlateList(rowData);
        }
      } else {
        // setBatchPlateList([]);
      }
    } catch (error) {
      return error;
    }

  }

  const handleClick = () => {
    setClicked(true); // Mark as clicked forever
    getPlateDetailsBySerielNo(selectedSerielNo);
  };

  // render all initial apis
  useEffect(() => {
    listPlateBatch()
    listSerialNumber()
  }, [])

  useEffect(() => {
    if (show === true && scanAreaRef.current) {
      scanAreaRef.current.focus();
    }
  }, [show])

  useEffect(() => {
    // Set a timer to update debouncedScanCode after 10 seconds
    const timerId = setTimeout(() => {
      setDebouncedScanCode(newResult);
    }, 3000);

    // Cleanup the timer if the component is unmounted or scanCode changes
    return () => clearTimeout(timerId);
  }, [newResult]);

  useEffect(() => {
    if (debouncedScanCode) {
      handleScanSerielNo(debouncedScanCode);
    }
  }, [debouncedScanCode]);


  return (
    <Modal
      className="top-right-modal"
      centered={false}
      show={show}
      size="lg"
    >
      <div>
        <CustomToast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={5000}
          message={toastMessage}
          toastType={toastType}
        // toastPosition='topLeft'
        />
        <div className="modalHead">
          <p className="modalHeadText ms-3 pt-3 p-2">
            {isPlateSampling
              ? "Plate Sampling"
              : isRawMaterialTest
                ? "Raw Material Test"
                : t("Exception.add_exception")}
          </p>
          <div onClick={() => handleModalClose()} className="p-2 mx-3 my-2 wrapCloseIcon">
            <TfiClose fill="#FFFFFF" />
          </div>
        </div>

        <div className='d-flex'>
          <div className="scanWrap p-3" style={{ "width": "48%" }}>
            <div className="scanInputWrap p-2">
              <input
                onChange={(e) => setResult(e.target.value)}
                placeholder={t('exceptionHandling.scanOnly')}
                value={newResult}
                ref={scanAreaRef}
              />
              {newResult && (
                <CiCircleRemove
                  onClick={() => setResult("")}
                  fontSize={30}
                  color="red"
                  className="m-1"
                  style={{ "cursor": "pointer" }}
                />
              )}
              <div 
              //onClick={handleModalOpen} 
              className="scanBg ">
                <BsQrCodeScan />
              </div>
            </div>
            {errors.scan_plate && (
              <p className="errorText p-0 m-0">{errors.scan_plate}</p>
            )}
          </div>

          <div className="scanWrap p-3" style={{ "width": "52%" }}>
            {/* <label style={{"display": "flex"}}>Search Area / Location / Equipment QR Code</label> */}
            <div className="scanInputWrap p-2">
              <input
                onChange={(e) => {
                  setSelectedSerielNo(e.target.value)
                  setClicked(false)
                }
                }
                placeholder={t('exceptionHandling.typeSearch')}
              />
              < IoSearchSharp
                fontSize={25}
                className='mt-1'
                color='grey'
                style={{ "cursor": "pointer" }}
                display={clicked ? "none" : ""}
                onClick={handleClick}
              />
            </div>
          </div>

        </div>

        {/* filter dropdown */}
        {isPlateSampling && isRawMaterialTest && (
          <div className="d-flex justify-content-end my-4" style={{ "visibility": "hidden" }}>
            <div style={{ "zIndex": "10" }} className='mx-2' >
              <label htmlFor="areaTypeSelect" className='filterLabelLeft'>{t('exceptionHandling.tableColumns.batch_code')}</label>
              <div style={{ "zIndex": "10" }}>
                <Select
                  options={plateBatches}
                  onChange={handleSelectChange}
                  placeholder={t('exceptionHandling.tableColumns.batch_code')}
                  isSearchable={true}
                  isClearable
                  className='areaTypeSelect2 me-3'
                />
              </div>
            </div>

            <div style={{ "zIndex": "10" }} className='mx-2' >
              <label htmlFor="areaTypeSelect" className='filterLabelLeft'>{t('exceptionHandling.tableColumns.seriel_number')}</label>
              <div style={{ "zIndex": "10" }}>
                <Select
                  options={plateSerielNum}
                  onChange={handleSelectChange}
                  placeholder={t('exceptionHandling.tableColumns.seriel_number')}
                  isSearchable={true}
                  isClearable
                  className='areaTypeSelect2 me-3'
                />
              </div>
            </div>
          </div>
        )}

        {/* {plateBySerielNo.length >= 1 && ( */}
        <div className="px-3 mx-2" style={{ "overflow": "scroll", "height": "180px" }}>
          <table className="custom-table">
            <thead >
              <tr className="tableHeadRow">
                {/* <th scope="col" className="tableHeadData2">{t('tableCommon.sl_no')} ({plateBySerielNo.length})</th> */}
                <th scope="col" className="tableHeadData2">{t('tableCommon.sl_no')} </th>
                <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.production_schedule')}</th>
                <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.product_name')}</th>
                <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.seriel_number')}</th>
                <th scope="col" className="tableHeadData2">{t('exceptionHandling.plateStatus')}</th>
                <th scope="col" className="tableHeadData2">{t('exceptionHandling.tableColumns.batch_code')}</th>
                <th scope="col" className="tableHeadData2">{t('exceptionHandling.remove')}</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={7} className="text-center py-4">
                    <div className="loader-container">
                      <div className="spinner"></div>
                      <p className="loading-text">Loading... Please wait</p>
                    </div>
                  </td>
                </tr>
              ) : plateBySerielNo.length > 0 ? (
                plateBySerielNo.map((obj: any, index: number) => (
                  <tr key={obj.plateSerielId || index}>
                    <td className="tableHeadData">{index + 1}</td>
                    <td className="tableHeadData">{obj.productionName}</td>
                    <td className="tableHeadData">{obj.productName}</td>
                    <td className="tableHeadData">{obj.plateSerielNo}</td>
                    <td className="tableHeadData">{obj.plateType}</td>
                    <td className="tableHeadData">{obj.batchId}</td>
                    <td className="tableHeadData">
                      <CiCircleRemove
                        onClick={() => handleRemovePlate(obj.plateSerielId)}
                        fontSize={25}
                        color="red"
                        style={{ "cursor": "pointer" }}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>

                  <td colSpan={7}>
                    <div className="empty-table-container">
                      <p className="empty-text">No data to display. Please try again</p>
                    </div>
                  </td>

                </tr>
              )}
            </tbody>

          </table>
        </div>
        {/* )} */}

        {/* <div className="selectWrap">
            <div className="form-group my-1">
              <label htmlFor="">{t("Exception.serial_id")}</label>
              <br />
              <input
                disabled
                value={
                  plateBySerielNo.length > 0
                    ? plateBySerielNo[0].plateSerielNo
                    : ""
                }
              />
            </div>

            <div className="form-group my-1">
              <label>{t("Exception.plate_type")}</label>
              <br />
              <input
                disabled
                value={
                  plateBySerielNo.length > 0 ? plateBySerielNo[0].plateType : ""
                }
              />
            </div>
          </div> */}
        {/* <div className="selectWrap">
            <div className="form-group my-1">
              <label htmlFor="">{t("Exception.batch")}</label>
              <br />
              <input
                disabled
                value={
                  plateBySerielNo.length > 0 ? plateBySerielNo[0].batchId : ""
                }
              />
            </div>

            <div className="form-group my-1">
              {!isPlateSampling && !isRawMaterialTest && (
                <>
                  <label htmlFor="">
                    {t("Exception.reason")}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <br />
                  <select
                    id=""
                    value={addExceptionData.reason_id}
                    name="reason_id"
                    onChange={handleAddExceptionChange}
                  >
                    <option value="select">select</option>
                    {exceptionReasons.map((reason, index) => (
                      <option key={index} value={reason?.id}>
                        {reason?.reason}
                      </option>
                    ))}
                    <option value="0">others</option>
                  </select>
                  {errors.reason_id && (
                    <p className="errorText">{errors.reason_id}</p>
                  )}
                </>
              )}

              {isPlateSampling && (
                <>
                  <label htmlFor="">
                    Plate Sampling Type<span style={{ color: "red" }}>*</span>
                  </label>
                  <br />
                  <select
                    id=""
                    value={addExceptionData.reason_id}
                    name="reason_id"
                    onChange={handleAddExceptionChange}
                  >
                    <option value="select">select</option>
                    {samleTestType.map((type, index) => (
                      <option key={index} value={type?.id}>
                        {type?.test_type}
                      </option>
                    ))}
                  </select>
                  {errors.reason_id && (
                    <p className="errorText">{errors.reason_id}</p>
                  )}
                </>
              )}

              {isRawMaterialTest && (
                <>
                  <label htmlFor="">
                    Sample Type<span style={{ color: "red" }}>*</span>
                  </label>
                  <br />
                  <select
                    id=""
                    value={addExceptionData.reason_id}
                    name="reason_id"
                    onChange={handleAddExceptionChange}
                  >
                    <option value="select">select</option>
                    {rawMaterialType.map((type, index) => (
                      <option key={index} value={type?.id}>
                        {type?.material_type}
                      </option>
                    ))}
                  </select>
                  {errors.reason_id && (
                    <p className="errorText">{errors.reason_id}</p>
                  )}
                </>
              )}
            </div>
          </div> */}
        <div className="selectWrap-new">
          <div className="form-group my-1 mx-3 px-1">
            {!isPlateSampling && !isRawMaterialTest && (
              <>
                <label htmlFor="">
                  {t("Exception.reason")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <select
                  id=""
                  value={addExceptionData.reason_id}
                  name="reason_id"
                  onChange={handleAddExceptionChange}
                >
                  <option value="select">{t('common.select')}</option>
                  {exceptionReasons.map((reason, index) => (
                    <option key={index} value={reason?.id}>
                      {reason?.reason}
                    </option>
                  ))}
                  <option value="0">{t('common.others')}</option>
                </select>
                {errors.reason_id && (
                  <p className="errorText">{errors.reason_id}</p>
                )}
              </>
            )}

            {isPlateSampling && (
              <>
                <label htmlFor="">
                  {t("exceptionHandling.plateSamplingType")}<span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <select
                  id=""
                  value={addExceptionData.reason_id}
                  name="reason_id"
                  onChange={handleAddExceptionChange}
                >
                  <option value="select">{t('common.select')}</option>
                  {samleTestType.map((type, index) => (
                    <option key={index} value={type?.id}>
                      {type?.test_type}
                    </option>
                  ))}
                </select>
                {errors.reason_id && (
                  <p className="errorText">{errors.reason_id}</p>
                )}
              </>
            )}

            {isRawMaterialTest && (
              <>
                <label htmlFor="">
                  {t("exceptionHandling.sampleType")}<span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <select
                  id=""
                  value={addExceptionData.reason_id}
                  name="reason_id"
                  onChange={handleAddExceptionChange}
                >
                  <option value="select">{t('common.select')}</option>
                  {rawMaterialType.map((type, index) => (
                    <option key={index} value={type?.id}>
                      {type?.material_type}
                    </option>
                  ))}
                </select>
                {errors.reason_id && (
                  <p className="errorText">{errors.reason_id}</p>
                )}
              </>
            )}
          </div>
          <div className="form-group my-1 mx-3">
            {isRawMaterialTest && (
              <>
                <label htmlFor="">
                  {t("exceptionHandling.subCategory")}<span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <select
                  id=""
                  value={addExceptionData.subCategory_id}
                  name="subCategory_id"
                  onChange={handleAddExceptionChange}
                >
                  <option value="select">{t('common.select')}</option>
                  {rawMaterialSub.map((type, index) => (
                    <option key={index} value={type?.id}>
                      {type?.material_type}
                    </option>
                  ))}
                </select>
                {errors.subCategory_id && (
                  <p className="errorText">{errors.subCategory_id}</p>
                )}
              </>
            )}
          </div>
        </div>

        <div className="d-flex justify-content-start">
          {addExceptionData.reason_id === "0" && (
            <div className="selectWrap justify-content-start ps-3">
              <div className="form-group ms-2 ps-1 ">
                <label htmlFor="">
                  {t("Exception.other")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <textarea
                  placeholder={t("Exception.other")}
                  className="otherReasonTextArea p-2"
                  value={addExceptionData.other_reason}
                  name="other_reason"
                  onChange={handleAddExceptionChange}
                // Add any necessary props for the text area
                />
                {errors.other_reason && (
                  <p className="errorText m-0 p-0">{errors.other_reason}</p>
                )}
              </div>
            </div>
          )}

          {!isPlateSampling && !isRawMaterialTest && (
            <div className="selectWrap justify-content-start ms-1 ps-3">
              <div className="form-group ms-2 ps-1 ">
                <label htmlFor="">
                  {t("Exception.remarks")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <textarea
                  placeholder={t("Exception.remarks")}
                  className="otherReasonTextArea p-2"
                  value={addExceptionData.remarks}
                  name="remarks"
                  onChange={handleAddExceptionChange}
                // Add any necessary props for the text area
                />
                {errors.remarks && (
                  <p className="errorText m-0 p-0">{errors.remarks}</p>
                )}
              </div>
            </div>
          )}
        </div>


        {/* {addExceptionData.reason_id === "0" && (
            <div className="selectWrap justify-content-start ps-3">
              <div className="form-group ms-2 ps-1 ">
                <label htmlFor="">
                  {t("Exception.other")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <br />
                <textarea
                  placeholder="Other"
                  className="otherReasonTextArea p-2"
                  value={addExceptionData.other_reason}
                  name="other_reason"
                  onChange={handleAddExceptionChange}
                  // Add any necessary props for the text area
                />
                {errors.other_reason && (
                  <p className="errorText m-0 p-0">{errors.other_reason}</p>
                )}
              </div>
            </div>
          )} */}
      </div>
      {/* {!isPlateSampling && !isRawMaterialTest && (
          <div className="selectWrap justify-content-start ps-3">
            <div className="form-group ms-2 ps-1 ">
              <label htmlFor="">
                {t("Exception.remarks")}
                <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <textarea
                placeholder="Remarks"
                className="otherReasonTextArea p-2"
                value={addExceptionData.remarks}
                name="remarks"
                onChange={handleAddExceptionChange}
                // Add any necessary props for the text area
              />
              {errors.remarks && (
                <p className="errorText m-0 p-0">{errors.remarks}</p>
              )}
            </div>
          </div>
        )} */}
      <div className="bottomArea">
        <button
          onClick={() => handleModalClose()}
          className="modalCancelBtn"
        >
          {t("buttons.cancel")}
        </button>
        <button
          onClick={() => handleExceptionAlert()}
          className="squareOrangeBtn3"
        >
          {t("buttons.submit")}
        </button>
        {/* <button className=' squareOrangeBtn3Disabled'>Submit</button> */}
      </div>
    </Modal>
  );
};

interface ScanAreaModelProps {
  show: boolean;
  onHide: () => void;
  webCamError: (error: any) => void;
  webCamScan: (result: string | null) => void;
}

export const ScanAreaModel: React.FC<ScanAreaModelProps> = ({
  show,
  onHide,
  webCamError,
  webCamScan,
}) => {

  const { t } = useTranslation();

  return (
    <Modal show={show} >
      <div className="scanModal">
        <div className="modalHead">
          <p className="modalHeadText2 mx-3 my-2">{t("exceptionHandling.scan")}</p>
          <div onClick={onHide} className="p-2 mx-2 ">
            <TfiClose fill="#FFFFFF" />
          </div>
        </div>

        <QrReader
          className="scan-web"
          delay={300}
          onError={webCamError}
          onScan={webCamScan}
          facingMode={"user"}
        />
      </div>
    </Modal>
  );
};
